import Styles from './styles.module.css';
import React, { useState } from 'react';
import { FaBookmark } from "react-icons/fa";
import { FaRegBookmark } from "react-icons/fa6";
import { MdMenuBook } from "react-icons/md";
import { HiOutlineDocumentText } from "react-icons/hi";
import { HiNewspaper } from "react-icons/hi2";
import { HiPlus } from "react-icons/hi";
import DefaultImage from "./../../../image/default/home.png";
import { doc, updateDoc, arrayUnion, getFirestore, arrayRemove } from 'firebase/firestore';
import { FaRegStar } from "react-icons/fa6";
import { FaStar } from "react-icons/fa6";
import { RiLockPasswordLine } from "react-icons/ri";
import { RiLockPasswordFill } from "react-icons/ri";
import BackCaution from "./backCaution/index";

type SchoolItemProps = {
  print: string[];
  schoolId: string;
  data: any;
  download: string[];
  setToggle: React.Dispatch<React.SetStateAction<any>>;
  save: string[];
  setSave: React.Dispatch<React.SetStateAction<string[]>>;
  block: string[];
  setBlock: React.Dispatch<React.SetStateAction<string[]>>;

  selectedIds: string[];
  setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
  searchPref: string;
  searchType: string;
};

const SchoolItem: React.FC<SchoolItemProps> = ({ print, schoolId, data, setToggle, save, setSave, block, setBlock, selectedIds, setSelectedIds, searchPref, searchType }) => {

  const handleCheckboxChange = (id: string, checked: boolean) => {
    setSelectedIds((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id)
    );
  };

  const handleSaveChange = (id: string, checked: boolean) => {
    setSave((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id)
    );
  };

  const handleBlockChange = (id: string, checked: boolean) => {
    setBlock((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id)
    );
  };

  const prefectures = data.storeTags?.filter((tag: string) =>
    /^(北海道|東京都|大阪府|京都府|.{2,3}県)$/.test(tag)
  );

  const db = getFirestore();

  const [ blockPopup, setBlockPopup ] = useState<string>("");

  return (
    <>
    <div data-testid="job-item" data-recruit-id={data.id} className={Styles.items_table}>
      <div className={Styles.items_table_box_1}>
        <input type="checkbox" className={Styles.items_checkbox}
          checked={selectedIds.includes(data.id)}
          onChange={(e) => handleCheckboxChange(data.id, e.target.checked)} />
        <img className={Styles.items_table_box_1_img} alt=""
          src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/companies_logo%2Fresize_images%2F${data.companyId}_200x200?alt=media&token=?0`}
          onError={(e) => e.currentTarget.src = DefaultImage} />
        <div className={Styles.items_table_box_post}>
          <div>
            <div style={print.includes(data.id) ? {backgroundColor: '#59C47C'} : {backgroundColor: '#D14F60'}}></div>
            <p>{print.includes(data.id) ? "印刷済み" : "未印刷"}</p>
          </div>
          <h2>{data.name}<span className={Styles.tooltip_text}>{data.name}</span></h2>
        </div>
      </div>
      <div className={Styles.items_table_box_2}>
        <h4>
          {prefectures?.join(", ")}
        </h4>
      </div>
      <div className={Styles.items_table_box_6} onClick={() => {setToggle({ type: "store", id: data.companyId, name: data.name })}} style={{ cursor: 'pointer' }}>
        <h4>{data.storeCount}店舗</h4>
      </div>
      <div className={Styles.items_table_box_3}>
        <h4>{data.title}</h4>
      </div>
      {/* 0人でも開ける(学校で卒業生を追加するため) */}
      <div className={Styles.items_table_box_5}>
        <button type="button" className={Styles.graduateBtn} title="卒業生を見る・追加する"
          aria-label={`卒業生 ${data.graduate}人(見る・追加する)`}
          onClick={() => setToggle({ type: "graduate", id: data.companyId, name: data.name })}>
          {data.graduate}人<span className={Styles.graduateBtnIcon} aria-hidden="true"><HiPlus /></span>
        </button>
      </div>

      <div style={{ flex: "1", alignItems: "center" }}></div>

      <HiOutlineDocumentText data-testid="job-item-detail-icon" className={Styles.icon}
        style={data.jobPostingsStatus ? { cursor: "pointer" } : {color: "#EBEBEB"}}
        onClick={() => {
          if (data.jobPostingsStatus) {
            setToggle({ type: "jobPosting", id: data.id, name: data.name })
          }}} />

      {/* パンフレット */}
      {data.pamphlet ?
      <a href={data.pamphlet ? `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/pamphlet%2F${data.id}?alt=media&token=` : undefined}
        onClick={(e) => { if (!(data.pamphlet)) { e.preventDefault(); } }}
        target="_blank" rel="noopener noreferrer">
        <MdMenuBook className={Styles.icon}  style={data.pamphlet ? {} : {color: "#EBEBEB"}} />
      </a>
      :
      <MdMenuBook className={Styles.icon}  style={{color: "#EBEBEB"}} /> }

      {data.recruitStatus ?
      <a href={data.recruitStatus ? `https://memorii-works.com/recruit/id=${data.id}` : undefined}
        onClick={(e) => { if (!(data.recruitStatus)) { e.preventDefault(); } }}
        target="_blank" rel="noopener noreferrer">
        <HiNewspaper className={Styles.icon} style={data.recruitStatus ? {} : {color: "#EBEBEB"}} />
      </a>
      :
      <HiNewspaper className={Styles.icon} style={{color: "#EBEBEB"}} /> }

      {Array.isArray(block) && block.includes(data.id) ?
      <FaStar
        className={Styles.box_6}
        style={{ color: "#EBEBEB" }} />
      :
      <>
      {Array.isArray(save) && save.includes(data.id) ? (
        <FaStar
          className={Styles.box_6}
          style={{ color: "#F5BE19" }}
          onClick={() => {
            handleSaveChange(data.id, false);
            const ref = doc(db, "schools", schoolId);
            updateDoc(ref, {
              recommendList: arrayRemove(data.id),
            });
          }}
        />
      ) : (
        <FaRegStar
          className={Styles.box_6}
          style={{ color: "#222222" }}
          onClick={() => {
            handleSaveChange(data.id, true);
            const ref = doc(db, "schools", schoolId);
            updateDoc(ref, {
              recommendList: arrayUnion(data.id),
            });
          }}
        />
      )}
      </> }

      {Array.isArray(save) && save.includes(data.id) ?
      <>
        <RiLockPasswordFill
          className={Styles.box_6}
          style={{ color: "#EBEBEB" }} />
      </>
      :
      <>
        {Array.isArray(block) && block.includes(data.id) ? (
          <RiLockPasswordFill
            className={Styles.box_6}
            style={{ color: "var(--mw-error)" }}
            onClick={() => {
              handleBlockChange(data.id, false);
              const ref = doc(db, "schools", schoolId);
              updateDoc(ref, {
                blockList: arrayRemove(data.id),
              });
            }}
          />
        ) : (
          <RiLockPasswordLine
            className={Styles.box_6}
            style={{ color: "#222222" }}
            onClick={() => {
              setBlockPopup(data.id);
            }}
          />
        )}
      </> }
    </div>

    {blockPopup !== "" ?
      <BackCaution blockPopup={blockPopup}  setBlockPopup={setBlockPopup} setBlock={setBlock} schoolId={schoolId} />
    : <></> }
    </>
  );
}

export default SchoolItem;
